import { render } from "./AutoCompleteMultiField.vue?vue&type=template&id=37f797ba&ts=true"
import script from "./AutoCompleteMultiField.vue?vue&type=script&lang=ts"
export * from "./AutoCompleteMultiField.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__